import { createSlice } from "@reduxjs/toolkit";

const InitialState = {
  isLoading: false,
};
const LoadingSlice = createSlice({
  name: "loading",
  initialState: InitialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    endLoading(state) {
      state.isLoading = false;
    },
  },
});

export const loadingAction = LoadingSlice.actions;
export default LoadingSlice;
